<template>
  <div class="login" v-loading="loading">
    <div class="login-left">
      <div class="brand-center">
        <div class="brand-name">杏 林 · 问 方</div>
        <div class="brand-line"></div>
        <div class="brand-subtitle">辩 证 施 治 · 智 慧 管 理</div>
        <div class="brand-line"></div>
      </div>
      <div class="copyright"><a class="link" href="https://beian.miit.gov.cn/">蜀ICP备19001477号</a> CopyRight ©
        成都杏林春堂中医门诊部有限公司</div>
    </div>
    <div class="login-right">
      <div class="loginbox" v-if="loginStatus == false">
        <div>
          <div class="system-title">
            <img class="system-logo" src="@/assets/images/logo.png" alt="logo">
            <span>杏林 · 问方管理系统</span>
          </div>
          <div class="logintitle">欢迎登录</div>
          <!-- 账号密码登录 -->
          <div v-if="type == '1'" class="acc">
            <el-input class="acc-input" prefix-icon="el-icon-user" type="text" v-model.trim="loginForm.username"
              placeholder="请输入手机号" @keyup.enter="login" clearable />
            <el-input class="acc-input" prefix-icon="el-icon-lock" type="password" v-model.trim="loginForm.password"
              placeholder="请输入密码" @keyup.enter="login" clearable />
            <el-button class="acc-button" type="primary" @click="login">登录</el-button>
          </div>
          <!-- 微信扫码登录 -->
          <div class="code-warp" v-if="type == '0'">
            <img :src="'data:image/png;base64,' + baseImg" class="code-img">
          </div>
        </div>
      </div>
      <!-- 选择进入查看的医馆 -->
      <div class="loginbox" v-if="loginStatus == true">
        <div class="logintitle">选择相应医馆进入系统</div>
        <div class="button_warp" v-if="step == 2">
          <div class="button_list">
            <el-button type="primary" plain v-for="item in depts" :key="item.deptId" :value="item.deptId"
              @click="saveDepts(item.deptId)">{{ item.deptName }}</el-button>
          </div>
        </div>
        <div class="button_warp" v-if="step == 1">
          <div class="button_list">
            <el-button type="primary" plain @click="changeRole(76)">诊所</el-button>
            <el-button type="primary" plain @click="changeRole(10)">医馆</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { createRoutes } from "@/router";
import { userInfo, checkLogin, routerList, getInQrCode } from "@/api/account"; // 账号请求
import { doctorList } from '@/api/doctor'
import { SystemTime, thresholdValue } from '@/config/systemTime'
import { Utils } from '@/utils/utils'
import { isEmptyArray, isNull, isString } from "../utils/validateBase";
import { deptDTO } from '@/DTO/index'
export default {
  data() {
    return {
      loginForm: { username: "", password: "" }, // 表单数据双向绑定
      imgUrl: "", // 验证码图片地址
      loginStatus: false, // 选框状态
      options: [], // 医馆选项
      depts: [], // 场馆信息
      loading: false, // 加载状态
      type: '1',//登录方式 0扫码 1账号密码
      baseImg: '',//二维码
      outpatientType: ['0', '1'],//跳转到门诊的type 医生0，医助1
      step: 1
    };
  },
  async created() {
    let systemTime = SystemTime.getSystemTime()
    SystemTime.correctDiffValue(systemTime)
    let diffValue = Math.abs(this.$session.get('diffValue'))
    if (Utils.gt(diffValue, thresholdValue)) {
      this.$message({
        type: "error",
        message: '检测到电脑时间与当前时间不符，请先设置正确时间',
        duration: 60 * 1000
      })
    }
    // this.getInQrCode()
  },
  methods: {
    // 登录
    async login() {
      this.loading = true
      let { data, code } = await checkLogin(this.loginForm);
      if (code == 200) {
        if (isString(data)) {
          this.step = 2
          this.$session.set("t_k", data);
          this.getAccInfo();
        } else if (!isEmptyArray(data)) {
          this.loginStatus = true
          this.loading = false
          this.step = 1
        }
      } else {
        this.loading = false
      }
    },
    // 获取用户数据
    async getAccInfo() {
      let { data, code } = await userInfo();
      if (code == 200) {
        this.depts = _.sortBy(data.depts, function (item) { return item.deptId });
        this.$session.set('user', data.user);
        this.$session.set('roles', data.roles);
        this.deptIds();
        // 获取后端返回的路由
        routerList().then(res => {
          if (res.code == 200) {
            // res.data[0].redirect = '/home';
            this.$session.set("menuList", res.data);
            this.loading = false
            this.loginStatus = true;
          } else {
            this.loading = false
          }
        });
      }
    },
    // 生成医馆选项
    deptIds() {
      if (this.depts.length > 0) {
        this.depts.forEach(item => { this.options.push({ label: item.deptName, value: item.deptId }) });
        this.$session.set("options", this.options);
      }
    },
    // 保存医馆id
    async saveDepts(deptId) {
      let { code, data } = await deptDTO.switchAndGetDept({ deptId: deptId + '' })
      if (code == 200) {
        this.$session.set("deptId", data.deptId);
        this.$session.set("ybDeptNum", data.ybDeptNum);
        this.$session.set("deptInfo", data);
        createRoutes();
        this.$message({
          type: 'success',
          message: '登录成功！',
          duration: '1000'
        })
        let user = this.$session.get('user')
        try {
          if (this.outpatientType.includes(user.type)) {
            this.$router.push("/doctorworkstation/newDiagnosis");
          } else {
            this.$router.push("/account/personal");
          }
        } catch (error) {
          this.$router.push("/account/personal");
        }
      }

    },
    // 获取所有医生列表
    async getDoctorList() {
      let { code, rows } = await doctorList()
      if (code == 200) {
        this.$session.set('doctorList', rows)
        this.loading = false
        this.loginStatus = true;
        this.loading = false
        this.loginStatus = true;
      }
    },
    /**
     * 获取登录二维码
     */
    async getInQrCode() {
      let { code, data } = await getInQrCode()
      if (code == 200) {
        this.baseImg = data.baseImg
      }
    },
    async changeRole(val) {
      this.loading = true
      let params = { ...this.loginForm, companyId: val }
      let { data, code } = await checkLogin(params);
      if (code == 200) {
        this.step = 2
        this.$session.set("t_k", data);
        this.getAccInfo();
      } else {
        this.loading = false
      }
    }
  },
};
</script>

<style lang="less" scoped>
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: hidden;
  background: #fff;

  .login-left {
    position: relative;
    width: 58.7%;
    height: 100%;
    background: url(../assets/images/login_bg.png) center center no-repeat;
    background-size: cover;
  }

  .brand-center {
    position: absolute;
    left: 50%;
    top: 41%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    letter-spacing: 5px;
    white-space: nowrap;
  }

  .brand-name {
    font-size: 34px;
    line-height: 40px;
    font-weight: 600;
    text-shadow: 0 2px 8px rgba(28, 111, 185, .25);
    margin-bottom: 24px;
  }

  .brand-line {
    width: 300px;
    height: 1px;
    background: rgba(255, 255, 255, .35);
  }

  .brand-subtitle {
    padding: 16px 0;
    font-weight: 400;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
  }

  .login-right {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
  }

  .loginbox {
    box-sizing: border-box;
    margin-top: -26px;
    display: flex;
    flex-direction: column;
  }

  .system-title {
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    font-weight: bold;
    font-size: 20px;
    color: #000000;
    letter-spacing: 1px;
  }

  .system-logo {
    width: 32px;
    height: 32px;
    margin-right: 8px;
    border-radius: 50%;
  }

  .logintitle {
    margin-bottom: 24px;
    font-weight: 600;
    font-size: 24px;
    color: #192533;
  }

  .icon-img {
    width: 78px;
    height: 78px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
  }

  .acc {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .acc-input {
    width: 324px;
    height: 44px;
    margin-bottom: 24px;

    /deep/.el-input__inner {
      width: 324px;
      height: 44px;
      line-height: 44px;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #F3F6F9 !important;
      overflow: hidden;
      border: 1px solid transparent;
    }

    /deep/.el-input__inner:hover,
    /deep/.el-input__inner:focus {
      border-color: #1890FF;
    }
  }

  .acc-button {
    display: block;
    width: 324px;
    height: 44px;
    margin-top: 18px;
    padding: 0;
    border: none;
    border-radius: 8px;
    background: #2d9bf0;
    box-shadow: 0 6px 12px rgba(45, 155, 240, .25);
    line-height: 38px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 4px;
  }

  .code-warp {
    width: 270px;
    height: 270px;
    background: #f5f9fc;
    display: flex;
    align-items: center;
    justify-content: center;

    .code-img {
      width: 230px;
      height: 230px;
    }
  }

  .button_warp {
    flex: 1;
    max-height: 500px;
    overflow-y: auto;
    padding: 8px;
    box-sizing: border-box;

    .button_list {
      display: grid;
      grid-template-columns: repeat(2, 154px);
      row-gap: 16px;
      column-gap: 16px;
    }

    .el-button {
      min-height: 38px;
      white-space: break-spaces;
      background: #E8F4FF;
      font-weight: 400;
      font-size: 14px;
      color: #1890FF;
      border-color: rgba(24, 144, 255, 0.40);
      border-radius: 4px;
    }

    /deep/.el-button+.el-button {
      margin-left: 0px !important;
    }
  }

  .copyright {
    position: absolute;
    left: 0;
    bottom: 28px;
    width: 100%;
    text-align: center;
    line-height: 24px;
    color: rgba(255, 255, 255, .82);
    font-size: 12px;
  }

  .link {
    font-size: 12px;
    color: rgba(255, 255, 255, .9);
    text-decoration: none !important;
    font-style: normal;
  }
}
</style>